import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import classNames from 'clsx';
import React, { useRef } from 'react';

import semanticClassNames from '../SocialPlayerVimeo.semanticClassNames';
import type { ISocialPlayerVimeoProps } from '../SocialPlayerVimeo.types';
import styles from './SocialPlayerVimeo.module.scss';
import { useVimeoPlayer } from './hooks/useVimeoPlayer';

const SocialPlayerVimeo: React.FC<ISocialPlayerVimeoProps> = ({
  id,
  className,
  customClassNames = [],
  url,
  description,
  autoPlay = false,
  loop = false,
  enabledControls = true,
  enabledTitle = true,
  startTime,
  endTime,
  onMouseEnter,
  onMouseLeave,
  ...props
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useVimeoPlayer({
    url,
    autoPlay,
    loop,
    enabledControls,
    enabledTitle,
    startTime,
    endTime,
    ref,
  });

  return (
    <div
      ref={ref}
      id={id}
      className={classNames(
        styles.root,
        className,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      style={{ display: 'flex', minHeight: 'fit-content' }}
      aria-label={description}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...getDataAttributes(props)}
    />
  );
};

export default SocialPlayerVimeo;
